import React from 'react';
import { Link } from 'react-router-dom';
import { CAMP_SEASON } from './summerCampContent';
export function SummerCampRelatedLinks() {
  return <section className="py-12 bg-subtle-gray/30 border-t border-subtle-gray" data-id="element-3281">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-3282">
        <p className="text-sm font-bold text-gray-warm uppercase tracking-wide mb-6" data-id="element-3283">
          Explore More Classes & Programs
        </p>
        <div className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-3284">
          <Link to="/karate-kids-classes.html" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-3285">
            Kids Classes
          </Link>
          <Link to="/Programs.html" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-3286">
            Programs Overview
          </Link>
          <Link to="/ContactUs.html" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-3287">
            Contact
          </Link>
          <a href={`tel:${CAMP_SEASON.mainPhone}`} className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-3288">
            Call {CAMP_SEASON.mainPhone}
          </a>
        </div>
      </div>
    </section>;
}